export default {
  catalog: 'Katalog',
  articles: 'Články',
  faq: 'FAQ',
  // Account sub-navigation
  account: 'Účet',
  dashboard: 'Přehled',
  orders: 'Objednávky',
  favorites: 'Oblíbené',
  settings: 'Nastavení',
  billing: 'Platby',
  // Wallet
  wallet: 'Peněženka',
  topUp: 'Dobít',
};
